module.exports = __webpack_public_path__ + "static/media/yellow_button2.c2fbfcba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yellow_button2.png
// module id = 46
// module chunks = 0